import * as Api from '@ViewModels';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

export const SAVED_SEARCHES_QUERY_KEY = 'contactSearch';

interface UseSavedSearchesQueryOptions {
	meta?: LevStandardQueryMeta;
}

export function useSavedSearchesQuery({
	meta,
}: UseSavedSearchesQueryOptions = {}): UseQueryResult<Api.ContactSearch[]> {
	const userSession = useUserSession();

	return useQuery({
		queryKey: [SAVED_SEARCHES_QUERY_KEY],
		queryFn: async () => {
			const data = await userSession.webServiceHelper.callAsync<Api.ContactSearch[]>(
				Api.UserSessionContext.composeApiUrl({
					urlPath: 'contactSearch',
					queryParams: { supportsOwnershipFilters: true },
				}),
				'GET'
			);
			return data ?? [];
		},
		staleTime: 5 * 60 * 1000, // 5 minutes
		meta,
	});
}
